import { CONFIGURATION_PROFILE_SERVICE_NAME, ConfigurationProfileServiceProvider } from './configuration-profile.service'

export const CONFIGURATION_PROFILE_SERVICES_MODULE_NAME = 'simax.services.configuration-profile'

const module = angular.module(CONFIGURATION_PROFILE_SERVICES_MODULE_NAME, [])

module.provider(CONFIGURATION_PROFILE_SERVICE_NAME, ConfigurationProfileServiceProvider)
